import { IIssueActivityUserChild } from '@kcftech/prometheus-client';
import { useRouteEntities } from 'contexts/RouteEntityContext';
import { CmmsDetails } from 'pages/Desk/issues/CmmsDetails';
import { toIssueUserInfo } from 'pages/Desk/issues/shared';
import { UserDetails } from 'pages/Desk/issues/UserDetails';
import { memo, useMemo, useRef } from 'react';
import { HoverTooltip } from 'shared/hover_tooltip/HoverTooltip';
import { UserAvatar } from 'shared/user_avatar/UserAvatar';

export type HoverAvatarProps = Readonly<{
    user?: IIssueActivityUserChild;
}>;

function HoverAvatarBase({ user }: HoverAvatarProps) {
    const { location } = useRouteEntities();
    const cmmsName = location?.WorkItemIntegration?.CmmsName;
    const anchorRef = useRef<HTMLDivElement>(null);

    const activityUserToIssueInfoUser = useMemo(
        () => (user ? toIssueUserInfo(user) : undefined),
        [user],
    );

    return (
        <>
            {user && (
                <UserAvatar
                    ref={anchorRef}
                    userId={user.UserId}
                    firstName={user.UserFirstName}
                    lastName={user.UserLastName}
                    size="2.4rem"
                    fontSize="1.2rem"
                />
            )}
            {!user && cmmsName && (
                <UserAvatar
                    ref={anchorRef}
                    userId={undefined}
                    firstName={cmmsName}
                    lastName={undefined}
                    isCmms
                    size="2.4rem"
                    fontSize="1.2rem"
                />
            )}
            {activityUserToIssueInfoUser && (
                <HoverTooltip anchorRef={anchorRef} noPadding stickyHover>
                    <UserDetails user={activityUserToIssueInfoUser} />
                </HoverTooltip>
            )}
            {!activityUserToIssueInfoUser && cmmsName && (
                <HoverTooltip anchorRef={anchorRef} noPadding stickyHover>
                    <CmmsDetails cmmsName={cmmsName} />
                </HoverTooltip>
            )}
        </>
    );
}

export const HoverAvatar = memo(HoverAvatarBase);
